import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import "./nav.css"

function NavBar() {
  const nav = {
    hidden: { opacity: 0, y: -200 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.17, 0.67, 0.83, 0.67],
      },
    },
    exit: {
      opacity: 0,
      y: -200,
      transition: {
        delayChildren: 0.25,
        duration: 0.5,
        ease: [0.17, 0.67, 0.83, 0.67],
      },
    },
  }

  const navItem = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.5, ease: [0.17, 0.67, 0.83, 0.67] },
    },
  }

  return (
    <motion.header variants={nav} initial="hidden" animate="show" exit="exit">
      <div className="container-fluid header-container">
        <motion.div
          variants={navItem}
          initial="hidden"
          animate="show"
          className="logo"
        >
          <Link to="/">
            <h1>
              Landof <span className="clr-accent serif-2">ORIGINS</span>
            </h1>
          </Link>
        </motion.div>
        <nav>
          <Link to="/about">
            <motion.button
              variants={navItem}
              initial="hidden"
              animate="show"
              className="btn btn-nav"
            >
              About us
            </motion.button>
          </Link>
          <Link to="/adventures">
            <motion.button
              variants={navItem}
              initial="hidden"
              animate="show"
              className="btn btn-nav"
            >
              Adventures
            </motion.button>
          </Link>
        </nav>
        <div className="menu">
          <div>
            <p>Menu</p>
            <p>Close</p>
          </div>
        </div>
      </div>
    </motion.header>
  )
}

export default NavBar
